/* eslint no-trailing-spaces: 0 */

const messages = {
  activate: {
    agreement_msg:
      'This service is brought to you by Aplix Corporation. By using this service, you agree' +
      'and consent to the Brita Pro USERS Terms of Service ( ' +
      '<a href="http://www.aplix.co.jp/en/legal/terms_britaprousers.php" target="_blank">Brita Pro USERS Terms of Service</a>,' +
      '<a href="http://www.aplix.co.jp/en/privacypolicy/privacypolicy_iot.php" target="_blank"> Privacy Policy for IoT Solurion</a>' +
      ') and arbitration before the International Chamber of Commerce for any disputes between us.'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/protectplus_britapro_com/translations/japanese.js